// extracted by mini-css-extract-plugin
export default {"box":"refundInitiationFilterPage_box__DKsDh","box__content":"refundInitiationFilterPage_box__content__66wvc"};